import { get } from "../../utils/object-helpers";
import { sendSortListingsEvent } from "../../utils/event-triggers";

class {
    onSeeAllOperation(url, tabName) {
        sendSortListingsEvent({ url, tabName });
    }
}

$ {
    const m = get(input, 'page.modules', {});
    const refs = get(input, '_moduleReferences', {});
    const isSmall = get(input, 'page.isSmall', false);
    const localIsSmall = get(input, 'isSmall', false);
    const dynamicModules = get(input, 'DYNAMIC_MODULES', null);
    const spinnerModule = get(m, 'LOADING_SPINNER_MODULE', {});
    const filtersModule = get(m, refs.filters || 'unknown', null);
    const paginationModule = get(m, refs.pagination || 'unknown', null);
    const promotedItemsModule = get(m, refs.promotedItems || 'unknown', {});
    const container = get(input, "containers.[0]", {});
    const title = get(input, "containers.[0].title", null);
    const subTitle = get(input, "containers.[0].subTitle", null);
    const cards = get(container, "cards", []);
    const imageSize = isSmall ? 170 : 300;
    const seeAllTextSpans = get(container, "seeAll.textSpans", []);
    const seeAllAction = get(container, "seeAll.action", {});
    const seeAllTracking = JSON.stringify(get(seeAllAction, "trackingList.0", {}));
    const spinnerIgnoreWildcard = refs.spinnerIgnoreWildcard;
    const seeAllOperation = refs.seeAllOperation;
    const tabName = refs.tabName;
    let sortModule;

    if (!dynamicModules || dynamicModules[refs.sort || 'unknown']) {
       sortModule = get(m, refs.sort || 'unknown', {});
    }
}

<macro|{ priority, hidden }| name="see-all-button">
    <if(!hidden)>
        <ebay-button
            class="str-marginals__footer--button black-btn"
            priority=priority
            size="large"
            href=seeAllAction.URL
            data-track=seeAllTracking
            fluid
        >
            <str-textual-display textSpans=seeAllTextSpans />
        </ebay-button>
    </if>
</macro>

<section class="str-items-grid app-layout__block--gutters">
    <if(title || sortModule)>
        <div class="str-marginals str-marginals__header">
            <str-title title=title subTitle=subTitle />
            <str-sort ...sortModule title=title tabName=tabName />
        </div>
    </if>
    <if(seeAllOperation)>
        <div
            tabindex="0"
            class="see-all-operation"
            data-track=seeAllTracking
            on-click("onSeeAllOperation", seeAllAction.URL, tabName)
        >
            <str-textual-display textSpans=seeAllTextSpans />
        </div>
    </if>
    <if(filtersModule)>
        <str-filters ...filtersModule tabName=tabName />
    </if>
    <if(promotedItemsModule)>
        <str-promoted-items ...promotedItemsModule page=input.page />
    </if>
    <if(cards.length)>
        <section class="str-items-grid__container">
            <for|card, idx| of=cards>
                <str-item-card key=idx ...card page=input.page class=card._type imageSize=imageSize isSmall=localIsSmall testId=("ig-"+card.listingId)/>
            </for>
        </section>
        <div class="str-marginals str-marginals__footer">
            <if(paginationModule && !isSmall)>
                <str-pagination ...paginationModule tabName=tabName />
                <see-all-button priority="secondary" hidden=seeAllOperation />
            </if>
            <else>
                <see-all-button priority="primary" hidden=seeAllOperation />
            </else>
        </div>
    </if>
    <str-loading-spinner ...spinnerModule spinnerId=tabName ignoreWildcard=spinnerIgnoreWildcard />
</section>
